export default __webpack_public_path__ + "static/media/bebel.a007b512.gif";